module.exports = __webpack_public_path__ + "img/noMessage.aa31c8bc.png";